import api from './api';

const authService = {
  async login(email, password) {
    const response = await api.post('/api/auth/login', { email, password });
    if (response.data.access_token) {
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('refresh_token', response.data.refresh_token);
      
      // Fetch user data after successful login
      try {
        const userResponse = await api.get('/api/auth/me');
        localStorage.setItem('user', JSON.stringify(userResponse.data));
      } catch (error) {
        console.error('Failed to fetch user data:', error);
      }
    }
    return response.data;
  },

  async register(userData) {
    const response = await api.post('/api/auth/register', userData);
    return response.data;
  },

  async logout() {
    try {
      await api.post('/api/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user');
    }
  },

  async refreshToken() {
    const refreshToken = localStorage.getItem('refresh_token');
    const response = await api.post('/api/auth/refresh-token', { refresh_token: refreshToken });
    if (response.data.access_token) {
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('refresh_token', response.data.refresh_token);
    }
    return response.data;
  },

  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    
    try {
      return JSON.parse(userStr);
    } catch (error) {
      console.error('Error parsing user data from localStorage:', error);
      // Clear corrupted data
      localStorage.removeItem('user');
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      return null;
    }
  },

  isAuthenticated() {
    return !!localStorage.getItem('access_token');
  },

  isSuperuser() {
    const user = this.getCurrentUser();
    return user?.role === 'superuser';
  },

  isAdmin() {
    const user = this.getCurrentUser();
    return ['superuser', 'landlord'].includes(user?.role);
  },

  isStaff() {
    const user = this.getCurrentUser();
    return ['superuser', 'landlord', 'caretaker'].includes(user?.role);
  },

  isTenant() {
    const user = this.getCurrentUser();
    return user?.role === 'tenant';
  },
};

export default authService;
